<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper" @click="$emit('closeModal')">
				<div class="row">
					<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
						<div class="modal-container" @click.stop>

						<div class="modal-header row" style="justify-content: flex-end;">
							<!-- <div class="col-6">
							<button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
							</div> -->
							<div class="col">
							<button type="button" class="close" @click="$emit('closeModal')">
								<span aria-hidden="true">&times;</span>
							</button>
							</div>
						</div>
						<!-- Start Modal Body -->
						<div class="modal-body" style="min-height:500px">
							<h4 class="title">Tambah TPL Asuransi</h4>
                            <!-- {{form}} -->

                            <div class="row">
                                <div class="col-md-4 mt-auto mb-auto ">
                                    <label class="label">ID Work Order<span style="color: red;">*</span></label>
                                </div>
                                <div class="col-md-1 mt-auto mb-auto">
                                    :
                                </div>
                                <div class="col-md-7">
                                    <MultiSelect
                                        class="w-100"
                                        v-model="form.form_source"
                                        :options="woList.map(x => x.form_code)"
                                        :custom-label="opt =>woList.find(x => x.form_code == opt).name"
                                        :close-on-select="true"
                                        :multiple="false"
                                        :allow-empty="false"
                                        :internal-search="false"
                                        placeholder="Cari Nomor Wo ( Ketik Minimal 3 Kata )"
                                        @search-change="debouceFunction"
                                    >
                                    </MultiSelect>
                                </div>
                            </div>
                            <hr>

                            <div class="text-center mt-2 mb-2" v-if="errorMessage">
                                <h4 style="color:red">{{errorMessage}}</h4>
                            </div>
                            <div class="mt-2 mb-2" v-else-if="tpl">
                                <h5 class="ml-2">Informasi Polis</h5>
                                <div class="border border-secondary rounded p-10">
                                    <div class="row ">
                                        <div class="col-md-4 mt-auto mb-auto ">
                                            <label class="label">Nomor Polis</label>
                                        </div>
                                        <div class="col-md-1 mt-auto mb-auto">
                                            :
                                        </div>
                                        <div class="col-md-7">
                                            <label class="label">{{tpl.policy_number}}</label>
                                        </div>
                                    </div>
                                    <div class="row text-left">
                                        <div class="col-md-4 mt-auto mb-auto ">
                                            <label class="label">Tanggal Kadaluarsa Polis</label>
                                        </div>
                                        <div class="col-md-1 mt-auto mb-auto">
                                            :
                                        </div>
                                        <div class="col-md-7">
                                            <label class="label">{{moment(tpl.policy_expiry).format('MMM DD, YY')}}</label>
                                        </div>
                                    </div>
                                    <div class="row text-left">
                                        <div class="col-md-4 mt-auto mb-auto ">
                                            <label class="label">Perusahaan Asuransi</label>
                                        </div>
                                        <div class="col-md-1 mt-auto mb-auto">
                                            :
                                        </div>
                                        <div class="col-md-7">
                                            <label class="label">{{tpl.insurance_company}}</label>
                                        </div>
                                    </div>
                                    <div class="row text-left">
                                        <div class="col-md-4 mt-auto mb-auto ">
                                            <label class="label">Jumlah TPL</label>
                                        </div>
                                        <div class="col-md-1 mt-auto mb-auto">
                                            :
                                        </div>
                                        <div class="col-md-7">
                                            <label class="label">Rp. {{numberWithCommas(tpl.tpl)}}</label>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mt-4">
                                    <div class="col-md-3 offset-md-3">
                                        <button
                                            class="w-100 btn btn-primary"
                                            @click="submitForm"
                                        >
                                            Selesai
                                        </button>
                                    </div>
                                    <div class="col-md-3">
                                        <button
                                            class="w-100 btn btn-danger"
                                            @click="$emit('closeModal')"
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
						</div>
						<!-- End Modal Body -->
					</div>
				</div>
			</div>
			<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
		</div>
  </div>

 
</transition>
</template>

<script>
import moment from 'moment'
import debounce from 'debounce'
import env from '@/env'
export default {
    created () {
		this.debouceFunction = debounce((query) => {
			this.woList = [{
				name : 'Loading.....',
				form_code : 'Loading.....'
			}]
			this.loadWorkOrder(query)
		} , 
		1000)
	},
	data () {
		return {
            form : {
                form_source : null,
                form_destination : null,
                limit : null,
                policy_id : null
            },
            woList : [],
            errorMessage : '',
            debouceFunction : null,
            moment
		}
	},
	mounted() {
        this.form.form_destination = this.form_destination
	},
	watch : {
		'form.limit' : function () {
			const result = this.form.limit.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(() => this.form.limit = result);
    	},
        'form.form_source' : function () {
            if(this.form.form_source)
                this.searchPolicy(this.form.form_source)
        }
	},
	methods : {
		submitForm () {
			this.$http.post('/api/v1/insurance/tpl' , this.form).then((resp) => {
				this.$store.dispatch('triggerAlert' , [true , 'TPL Selesai Di Simpan'])
				this.$emit('done')
				// this.$emit('closeModal')
			})
			.catch((err) => {
				console.log(err)
				this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong.'])
			})



		},
        async searchPolicy (workorder) {
            try {
                // Search Policy From 
                let response = await this.$http.get('/api/v1/insurance/tpl/workorder?form_source=' + workorder)
                let data = response.data.data

                this.errorMessage = null

                this.tpl = data;
                // console.log(data)
                this.form.policy_id = data.id
                this.form.limit = parseFloat(data.tpl)
            }
            catch(err) {
                console.log(err.response.data.data)
                this.errorMessage = err.response.data.data
            }
        },
        async loadWorkOrder (search = null) {
			// this.woList = [];

			let queryParam = ''

			if(search) {
				queryParam += `&search=${search}`
			}

			console.log(queryParam)

			this.$http.get('/api/v1/masterData/workorder?pagination=false&order=DESC&by=created_at' + queryParam)
			.then((resp) => {
				// this.woList = resp.data.data
				this.$set(this , 'woList' , resp.data.data)

				for(var i = 0 ; i < this.woList.length ; i++) {
					this.woList[i].name = this.woList[i].form_code + ' - ' + this.woList[i].no_polisi + ' - ' + this.woList[i].car_name
				}
				// console.log(this.woList)
			})
			.catch((err) => { 
                console.log(err) 
            })
		}
	},
	props : ['form_destination']
}
</script>

<style>

/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
  outline: none;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
}

.input--style-4 {
  line-height: 50px;
  background: #fafafa;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #666;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #666;
}

.input--style-4:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #666;
  opacity: 1;
}

.input--style-4::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #666;
  opacity: 1;
}

.input--style-4:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #666;
}

.input--style-4:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #666;
}

.label {
  font-size: 16px;
  color: #555;
  text-transform: capitalize;
  display: block;
  margin-bottom: 5px;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
  background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
  display: block;
}

.radio-container .checkmark:after {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #57b846;
}

.checkmark {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e5e5e5;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.input-group {
  position: relative;
  /* margin-bottom: 22px; */
  padding:20px;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  font-size: 18px;
  color: #999;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
  font-size: 40px;
  color: #525252;
  margin-bottom: 40px;
  text-align: center;
}


/* FILE DRAG N' DROP START */
.dropZone {
  /* width: 80%; */
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone:hover {
  border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
  color: #1975A0;
}

.dropZone-info {
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5C5C5C;
  opacity: 0.8;
}

.dropZone-uploaded {
  /* width: 80%; */
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.removeFile {
  width: 200px;
}
/* FILE DRAG N' DROP END */

.label {
    text-align: left !important;
}

</style>
